
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import PIDetails from "./index.vue";
@Component({
  name: "editQuotation",
  components: {
    PIDetails,
  },
})
export default class extends Vue {}
